import * as React from 'react';
export const pluxeeSvg = React.forwardRef(function pluxeeSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#00EB5E',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7 9.887v2.89l1.598 1.601 1.602 1.605-1.602 1.604L7 19.19l.007 2.897.01 2.897 2.892.01L12.8 25l1.598-1.601L16 21.794l1.602 1.605L19.2 25l2.891-.007 2.892-.01.01-2.897.007-2.897-1.598-1.602-1.602-1.604 1.602-1.605 1.598-1.6V7h-5.835l-1.58 1.584L16 10.171l-1.584-1.587L12.835 7H7v2.887Z',
      fill: '#221C46',
    }),
  );
});
pluxeeSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var pluxee = {
  category: 'brand',
  colorable: false,
  name: 'pluxee',
  svg: pluxeeSvg,
};
